import React, {useState} from 'react';
import styled from 'styled-components';

/**
 * props:
 *      handleClick - set callback from parent. Prop will call the callback with parameter equal to it's mode: 'list', 'grid'
 */




const BodyDiv = styled.div`
    border-radius: 9px;
    background: #E2E2E2;
    height: 44px;
    width: 93px;
`;

const FaceDiv = styled.div`
    background: rgba(255, 255, 255, ${props => props.opacity ? props.opacity : '1'} );
    border-radius: 9px;
    position: relative;
    top: ${props => props.top ? props.top : '2px'};
    left: ${props => props.left ? props.left : '2px'};
    height: 40px;
    padding-top: 7px;
    padding-left: 9px;
    width: 40px;

    :hover {
        cursor: pointer;
    }
`;

const LineDiv = styled.div`
    background: #1D599B;
    height: 2px;
    margin-top: 5px;
    width: 22px;

    background: ${props => props.selected == '1' ? '#1D599B' : '#C4C4C4' };
`;

const SquareDiv = styled.div`
    height: 8px;
    width: 8px;
    position: absolute;

    background: ${props => props.selected == '1' ? '#1D599B' : '#C4C4C4' };
    left: ${props => props.x ? props.x : '0px'};
    top: ${props => props.y ? props.y : '0px'};
`;


const ListFace = (props) => {
    return (
        <FaceDiv onClick={props.clickedCb} opacity={props.opacity}>
            <LineDiv className="line1" selected={props.selected} />
            <LineDiv className="line2" selected={props.selected} />
            <LineDiv className="line3" selected={props.selected} />
        </FaceDiv>
    );
}

const GridFace = (props) => {
    return (
        <FaceDiv onClick={props.clickedCb} left="51px" top="-38px" opacity={props.selected}>
            <SquareDiv x="10px" y="10px" selected={props.selected} />
            <SquareDiv x="20px" y="10px" selected={props.selected} />
            <SquareDiv x="10px" y="20px" selected={props.selected} />
            <SquareDiv x="20px" y="20px" selected={props.selected} />
        </FaceDiv>
    );
}


const ViewAsToggleComponent = (props) => {

    const [mode, setMode] = useState('list');

    const setToList = () => {
        setMode('list');
        props.handleClick('list');
    }

    const setToGrid = () => {
        setMode('grid');
        props.handleClick('grid');
    }

    return (
            <BodyDiv>
                <ListFace selected={mode == 'list' ? '1' : '0'} clickedCb={setToList} opacity={mode == 'list' ? '1' : '0'} />
                <GridFace selected={mode == 'grid' ? '1' : '0'} clickedCb={setToGrid} opacity={mode == 'grid' ? '1' : '0'} />
            </BodyDiv>
    );
}

export default ViewAsToggleComponent;